import { useEffect, useMemo } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { useShallow } from 'zustand/react/shallow'
import { useCADPageStore } from '@/state'
import { ThreeOutlineEffect } from '@/lib/cad/ThreeOutlineEffect'

export const useThreeOutlineEffect = () => {
  const { gl, invalidate, size } = useThree()
  const renderMode = useCADPageStore(useShallow((state) => state.renderMode))
  const isEnabled = renderMode === 'black-and-white-wireframe'

  const outlineEffect = useMemo(() => new ThreeOutlineEffect({ gl }), [gl])

  useEffect(() => {
    outlineEffect.start({ width: size.width, height: size.height, invalidate })
  }, [gl, invalidate, outlineEffect, size.height, size.width])

  useFrame(({ scene, camera }) => {
    if (isEnabled) {
      outlineEffect.render(scene, camera)
    }
  }, outlineEffect.renderPriority)
}
